import type { SxProps, Theme } from '@mui/material/styles';

type VehicleDetailStyleMap = {
    loadingContainer: SxProps<Theme>
    root: SxProps<Theme>
    homeBreadcrumbLink: SxProps<Theme>
    garageBreadcrumbLink: SxProps<Theme>
    headerRow: SxProps<Theme>
    titleRow: SxProps<Theme>
    vinChip: SxProps<Theme>
    headerActions: SxProps<Theme>
    card: SxProps<Theme>
    tabs: SxProps<Theme>
    tab: SxProps<Theme>
    mainContent: SxProps<Theme>
    overviewSection: SxProps<Theme>
    lastServicePaper: SxProps<Theme>
    lastServiceRow: SxProps<Theme>
    orderServiceLink: SxProps<Theme>
    sidebar: SxProps<Theme>
    machineInfoContent: SxProps<Theme>
    odometerRow: SxProps<Theme>
    odometerItem: SxProps<Theme>
    chartHeader: SxProps<Theme>
    chartContent: SxProps<Theme>
    actionsHeader: SxProps<Theme>
    actionsContent: SxProps<Theme>
    actionButton: SxProps<Theme>
    dialogActions: SxProps<Theme>
};

export const vehicleDetailStyles: VehicleDetailStyleMap = {
    loadingContainer: { display: 'flex', justifyContent: 'center', mt: 8 },
    root: { display: 'flex', flexDirection: 'column', gap: 3 },
    homeBreadcrumbLink: { display: 'flex', alignItems: 'center', color: 'text.secondary', textDecoration: 'none' },
    garageBreadcrumbLink: { color: 'text.secondary', textDecoration: 'none', fontSize: 14 },
    headerRow: { display: 'flex', flexDirection: { xs: 'column', md: 'row' }, justifyContent: 'space-between', alignItems: { md: 'center' }, gap: 2 },
    titleRow: { display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' },
    vinChip: { fontFamily: 'monospace' },
    headerActions: { display: 'flex', gap: 1.5 },
    card: { border: '1px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden' },
    tabs: { borderBottom: '1px solid', borderColor: 'divider', px: 2 },
    tab: { textTransform: 'none' },
    mainContent: { p: 3 },
    overviewSection: { display: 'flex', flexDirection: 'column', gap: 3 },
    lastServicePaper: { p: 2, borderRadius: 1.5 },
    lastServiceRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
    orderServiceLink: { display: 'flex', alignItems: 'center', gap: 0.5, color: 'primary.main', textDecoration: 'none', fontSize: 14, fontWeight: 500 },
    sidebar: { display: 'flex', flexDirection: 'column', gap: 2.5 },
    machineInfoContent: { p: 2.5, display: 'flex', flexDirection: 'column', gap: 2 },
    odometerRow: { display: 'flex' },
    odometerItem: { flex: 1 },
    chartHeader: { px: 2, py: 1.5, borderBottom: '1px solid', borderColor: 'divider' },
    chartContent: { p: 2 },
    actionsHeader: { px: 2.5, py: 1.5, borderBottom: '1px solid', borderColor: 'divider' },
    actionsContent: { p: 2, display: 'flex', flexDirection: 'column', gap: 1 },
    actionButton: { justifyContent: 'flex-start' },
    dialogActions: { px: 3, pb: 2 },
};

export const getVehicleDetailTransferTabStyles = (show: boolean): SxProps<Theme> => ({
    textTransform: 'none',
    display: show ? undefined : 'none',
});
